<template>
  <div class="colleges">
    <div class="head_bg_">
      <el-image
        :src="imagePath.headPng"
        fit="cover"
        class="headPng-j"
      ></el-image>
    </div>

    <!-- 院校logo展示主体部分 -->
    <div class="collegesLogoBar">
      <div class="bgImage-up">
        <el-image :src="imagePath.colleges_bg_up" fit="fill"></el-image>
      </div>

      <div class="logoShowBar">
        <div class="container collegesContainer">
          <div
            class="img_bar_"
            v-for="(item, index) in config.colleges"
            :key="'imgBar' + index"
            @mouseover.stop="mouseIn(item.link, index)"
            @mouseout.stop="mouseOut()"
          >
            <div class="float_red_bar_" v-show="isActive == index">
              <el-button
                class="go-detail-btn"
                @click.stop="openDetails(item.link)"
                >查看详情</el-button
              >
            </div>
            <div
              class="itemImg-Bar_v"
              @click.stop="openDetailsBefore(item.link)"
            >
              <el-image
                :src="require('@/assets/images/whkcsz/' + item.pic)"
                fit="contain"
              ></el-image>
            </div>
          </div>
          <i v-for="i in 3" :key="'site' + i" class="site_i"></i>
        </div>
      </div>
    </div>

    <div class="bgImage-down">
      <el-image :src="imagePath.colleges_bg_down" fit="fill"></el-image>
    </div>
  </div>
</template>

<script>
import headPng from "@/assets/images/whkcsz/colleges_head_pc.png";
import colleges_bg_up from "@/assets/images/whkcsz/colleges_bg_up.png";
import colleges_bg_down from "@/assets/images/whkcsz/colleges_bg_down.png";

import config from "../config";

export default {
  data() {
    return {
      config,
      imagePath: {
        headPng,
        colleges_bg_up,
        colleges_bg_down,
      },
      isActive: null,
    };
  },
  methods: {
    mouseIn(link, item) {
      if (link) {
        this.isActive = item;
      }
    },
    mouseOut() {
      this.isActive = null;
    },
    // 打开详情
    openDetails(link) {
      window.open(link, "_blank");
    },
    openDetailsBefore(linck) {
      if (linck) {
        this.openDetails(linck);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.colleges {
  position: relative;
  background: rgba(243, 243, 249, 0.51);
  min-height: 100%;
}
.head_bg_ {
  width: 100%;
  height: 120px;
  @media screen and (max-width: 767px) {
    height: auto;
  }
}
// 主体部分
.collegesLogoBar {
  position: relative;
  width: 100%;
}
.bgImage-up {
  position: absolute;
  width: 100%;
  top: 0px;
  z-index: 2;
}

.logoShowBar {
  position: relative;
  width: 100%;
  z-index: 3;
}

.bgImage-down {
  position: absolute;
  width: 100%;
  bottom: 0px;
  z-index: 2;
}

.collegesContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 60px;
  padding-bottom: 44px; //80-36
  .img_bar_ {
    width: calc(25% - 18px);
    height: 108px;
    margin-bottom: 36px;
    background: #ffffff;
    position: relative;
    .itemImg-Bar_v {
      height: 100%;
      width: 100%;
      padding: 30px 20px;
      display: flex;
      .el-image {
        height: 100%;
        width: 100%;
        margin: auto;
      }
    }
    .float_red_bar_ {
      position: absolute;
      height: 100%;
      width: 100%;
      background: rgba(205, 34, 36, 0.9);
      z-index: 9;
      display: flex;
    }
    @media screen and (max-width: 767px) {
      width: calc(50% - 7.5px);
      height: 50.8px;
      margin-bottom: 15px;
      .itemImg-Bar_v {
        padding: 11px 30px;
      }
      .float_red_bar_ {
        z-index: -1;
      }
    }
  }
  .site_i {
    width: calc(25% - 18px);
    @media screen and (max-width: 767px) {
      width: calc(50% - 7.5px);
    }
  }
}

.go-detail-btn {
  padding: 7px 20px;
  margin: auto;
  background: #ffffff;
  border-radius: 4px;
  font-size: 12px;
  color: #cd2224;
  line-height: 18px;
  font-weight: 400;
}
.headPng-j {
  height: 100%;
  width: 100%;
}

@media screen and (max-width: 767px) {
  .headPng-j {
    content: url("../../../assets/images/whkcsz/colleges_head_ph.png");
    width: 100%;
    height: auto;
  }
  .collegesContainer {
    padding-top: 20px;
    padding-bottom: 25px;
  }
}
</style>
